import type { QueryClient } from '@tanstack/react-query';

/**
 * POS-I324: the location list is read under several query keys ('locations', 'locations-list' in the
 * header picker and Reports, 'locations-list-employees', 'locations-list-for-movements'). Anything
 * that adds, renames, deactivates, reactivates or re-defaults a location calls this so every one of
 * them refreshes at once, instead of waiting for the 60 s stale time.
 */
export function invalidateLocationQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: (q) => typeof q.queryKey[0] === 'string' && (q.queryKey[0] === 'locations' || q.queryKey[0].startsWith('locations-')),
  });
}
